import { Navigate } from 'react-router-dom';
import useAuthStore, { isProfileComplete } from '../store/useAuthStore';
import { PATHS } from './navConfig';

/* The sign-up wizard sits between the two other guards: it needs the session
   OTP verification just created (every step calls the API as the new user), but
   it's unreachable once the account is set up. */
export default function SignupRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  if (!isAuthenticated) return <Navigate to={PATHS.LOGIN} replace />;
  if (isProfileComplete(user)) return <Navigate to={PATHS.DASHBOARD} replace />;
  return children;
}
